import { createAction } from "@reduxjs/toolkit";


export const changeModalStatus = 
createAction('global/ChangeModalStatus');

export const updateBalance = createAction
('global/UpdateBalance')